import React, { useState, useEffect, useCallback } from "react"
import { useParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { makeNewConditional } from "lib/utils/conditionals"
import { CollectionLoader } from "lib/components"
import { ConditionalProvider, ConditionalWorkingArea, useConditional } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"


export default function ConditionalEditor({ conditionalObj }:{ conditionalObj?:any}){

  const { dspid } = useParams()

  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { update }:any = AppStore

  const { apiValueLookup } = useConditional()
  const { currentConditional, updateConditional }:any = useConditionalCtx()

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("template.findById", { _id: dspid })
  const { data:_Conditionals } = queryTools.resource.parseQueryForApi("conditional.findAll", {})

  const [ createNew, setCreateNew ] = useState<any>(false)
  const [ saveOp, setSaveOp ] = useState<string>("")

  const makeSelected = useCallback((cond:any) => {
    updateConditional(cond)
  },[])

  function getAvailableConditionals(){
    return _Conditionals?.filter((cond:any) => cond.template_id === null || cond.template_id === _Dispute?._id) || []
  }

  const sidemenuOptClasses = (item:any, activeId:string) => {
    return cn(
      "w-full px-2 py-1 text-sm flex justify-start items-center cursor-pointer hover:bg-slate-600/70",
      activeId === item._id ? "bg-slate-800 text-white" : "bg-transparent",
      item.name === "---" && "h-0 mt-[-2px] border-t border-dotted border-slate-700"
    )
  }

  const saveOps = [{ _id: "add", name: "Add New" }, {_id: "div1", name: "---" }, { _id: "template", name: "Save for Template" }, { _id: "global", name: "Save Globally" }, { _id: "clone", name: "Clone" }, {_id: "div2", name: "---" }, { _id: "delete", name: "Delete" }]

  // updateConditional comes from the Conditional Provider, which loads earlier on the Conditionals page
  useEffect(() => {
    if( updateConditional !== undefined ){
      makeSelected(conditionalObj)
    }
  },[makeSelected, updateConditional])

  useEffect(() => {
    if(!store.actives.statement.conditional){
      update("actives.statement.conditional", makeNewConditional()) 
    }
  },[store.actives.statement.conditional])

  return (
    <div className="w-full flex flex-col grow overflow-y-hidden overflow-x-hidden pt-6">
      <div className="w-full h-full h-[24rem] flex justify-start gap-3">
        <div className="w-3/12 h-[34rem] grow flex flex-col border border-solid border-slate-700 relative overflow-auto scrollbar">
          <CollectionLoader 
            title="Conditionals Loader"
            collection={getAvailableConditionals() || []} 
            labelProp="name" 
            showDescriptions={true}
            draggable={true}
            // selectFn={(item:any) => StatementTools.loadStatement(item)} 
          />
        </div>

        { store.actives.statement.conditional !== null && (
          <div className="w-9/12 mr-[1%] flex flex-col items-stretch">
            <p>work needed</p>
            {/* <ConditionalProvider usage="statement">
              <ConditionalWorkingArea />
            </ConditionalProvider> */}
          </div>
        )}
      </div>
    </div>
  )
}

/*

          {/* <Tabset tabs={["Applied", "Available"]}>
            <div id="Applied" className="w-full h-full">
              <ResourceListArea 
                className="w-full" 
                collection={appState.template.build.statement.conditions}
                selectFn={loadConditional}
                is_selected={ (_id:string) => appState.template.build.selected?._id === _id }
                resource="statements"
                label="name"  
              />
            </div>

            <div id="Available" className="w-full h-full">
              <ResourceListArea 
                className="w-full" 
                collection={conditionals?.filter((cond:any) => cond.template_id === null || cond.template_id === appState.template.build.selected?._id) || []}
                selectFn={loadConditional}
                is_selected={ (_id:string) => appState.template.build.selected?._id === _id }
                resource="statements"
                label="name"  
              />
            </div>
          </Tabset>

          <div 
            onClick={() => setCreateNew(true)}
            className="w-[calc(100%-4px)] h-8 absolute bottom-[2px] left-[2px] bg-slate-700 flex justify-center items-center cursor-pointer"
          >
            <span>new conditional</span>
          </div>
*/